import { render } from "./SignIntegrationApp.vue?vue&type=template&id=791771f0&scoped=true"
import script from "./SignIntegrationApp.vue?vue&type=script&lang=js"
export * from "./SignIntegrationApp.vue?vue&type=script&lang=js"

import "./SignIntegrationApp.vue?vue&type=style&index=0&id=791771f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791771f0"]])

export default __exports__